import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function ShopTitle() {
  return <section data-section-id="162035" id="shop-title" className="relative bg-background overflow-hidden py-16 md:py-24 dark">
      {}
      <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold text-foreground tracking-tighter uppercase mb-6">
          Digital Catalog
        </h1>

        <Breadcrumb>
          <BreadcrumbList className="text-muted-foreground justify-center sm:justify-center">
            <BreadcrumbItem>
              <BreadcrumbLink asChild className="hover:text-primary transition-colors">
                <Link to="#">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-border" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-foreground font-default font-medium">Shop</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </section>;
}